import styled from 'styled-components';

export const InfoPageItalicText = styled.span`
  font-style: italic;
`;
